import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SalienteLibrarySharedModule } from "@saliente/library";
import { ClientFormsService } from "../client-forms.service";
import { DuPFA2025FormComponent } from "./dupfa2025-form.component";
import { DuPFA2025Component } from "./du-pfa-2025.component";
import { ChirieDuPFA2025Component } from "./chirie-du-pfa-2025.component";
import { ActivitateIndependentaDuPFA2025Component } from "./activitate-independenta-du-pfa-2025.component";

@NgModule({
    imports: [
		CommonModule, FormsModule, SalienteLibrarySharedModule
	],
	providers: [
		ClientFormsService
	],
	declarations: [
		DuPFA2025FormComponent, DuPFA2025Component, ChirieDuPFA2025Component, ActivitateIndependentaDuPFA2025Component
	],
	exports: [
		DuPFA2025FormComponent, 
	]
})
export class DuPFA2025SharedModule { }